export default __webpack_public_path__ + "static/favicon-d684f30b5f43f83d76945c842e79c345.ico";